// 全サービスの単一データソース：一覧カードと詳細ページの両方で使用
import petHospitalImg from '../assets/images/pet-hospital.JPG';
import petGroomingImg from '../assets/images/pet-grooming.JPG';
import petHotelImg from '../assets/images/pet-hotel.JPG';
import petTransportationImg from '../assets/images/pet-transportation.JPG';
import petShopImg from '../assets/images/pet-shop.JPG';

const services = [
  {
    slug: 'pet-hospital',
    icon: 'medical_services',
    name: 'โรงพยาบาลสัตว์',
    cardTitle: 'โรงพยาบาลสัตว์',
    shortDescription:
      'ตรวจ วินิจฉัย รักษา และผ่าตัด ครบวงจรโดยทีมสัตวแพทย์ผู้เชี่ยวชาญ',
    image: petHospitalImg,
    detail: {
      title: 'โรงพยาบาลสัตว์ One Stop Service ที่ทองหล่อ 20',
      intro:
        'โรงพยาบาลสัตว์ Pet Direct Hospital ตั้งอยู่ที่ทองหล่อ 20 ถนนสุขุมวิท กรุงเทพฯ เป็นโรงพยาบาลสัตว์แบบครบวงจรที่ให้บริการทุกด้านของสุขภาพสัตว์เลี้ยงของคุณ ด้วยทีมสัตวแพทย์ผู้เชี่ยวชาญและอุปกรณ์ทางการแพทย์ที่ทันสมัย เรามุ่งมั่นที่จะให้การดูแลที่ดีที่สุดสำหรับสุนัขและแมวของคุณ',
      featuresTitle: 'บริการของเรา',
      features: [
        'การตรวจรักษาโรคทั่วไปและโรคเฉพาะทาง',
        'การฉีดวัคซีนป้องกันโรคที่สำคัญ',
        'การผ่าตัดด้วยเทคโนโลยีทันสมัย',
        'การดูแลทันตกรรมเพื่อสุขภาพช่องปากที่ดี',
        'การตอบสนองฉุกเฉิน 24 ชั่วโมง',
        'การให้คำปรึกษาด้านโภชนาการและการดูแลสุขภาพ',
      ],
      sections: [
        {
          heading: 'ทำไมต้องเลือก Pet Direct Hospital?',
          body: 'เราเป็นโรงพยาบาลสัตว์แบบ One Stop Service ที่ให้บริการทุกความต้องการของสัตว์เลี้ยงในที่เดียว ไม่ว่าคุณจะต้องการการตรวจสุขภาพประจำ การดูแลฉุกเฉิน หรือคำแนะนำในการดูแลสัตว์เลี้ยง ทีมงานของเราพร้อมให้บริการด้วยความเอาใจใส่และความเป็นมืออาชีพสูงสุด',
        },
        {
          heading: 'เทคโนโลยีและอุปกรณ์ที่ทันสมัย',
          body: 'โรงพยาบาลของเรามีอุปกรณ์ทางการแพทย์ที่ทันสมัย เช่น เครื่องเอกซเรย์ดิจิตอล เครื่องอัลตราซาวด์ และเครื่องวินิจฉัยโรคขั้นสูง เพื่อให้การวินิจฉัยและการรักษาเป็นไปอย่างรวดเร็วและแม่นยำ',
        },
        {
          heading: 'ตารางนัดหมายและราคา',
          body: 'เรามีตารางนัดหมายที่ยืดหยุ่นและสามารถปรับเปลี่ยนได้ตามความสะดวกของคุณ ราคาของเราถูกกำหนดอย่างเป็นธรรมและคุ้มค่ากับบริการที่คุณจะได้รับ นอกจากนี้ เรายังมีโปรโมชั่นพิเศษสำหรับลูกค้าที่ใช้บริการอย่างต่อเนื่อง',
        },
      ],
    },
  },
  {
    slug: 'pet-grooming',
    icon: 'content_cut',
    name: 'อาบน้ำ-ตัดขน',
    cardTitle: 'บริการตัดขนสัตว์เลี้ยง',
    shortDescription:
      'อาบน้ำ ตัดขน ตัดเล็บ โดยช่างมืออาชีพ เพื่อความสวยงามและสุขภาพที่ดี',
    image: petGroomingImg,
    detail: {
      title: 'บริการอาบน้ำ-ตัดขนสัตว์เลี้ยงโดยมืออาชีพ',
      intro:
        'บริการอาบน้ำตัดขนของโรงพยาบาลสัตว์เพ็ทไดเร็คให้ความสำคัญกับสุขอนามัยและความสวยงามของสัตว์เลี้ยง โดยทีมงานผู้เชี่ยวชาญพร้อมดูแลอย่างใส่ใจ ใช้ผลิตภัณฑ์คุณภาพสูงที่ปลอดภัยสำหรับสัตว์ทุกชนิด เพื่อให้สัตว์เลี้ยงของคุณสะอาด สุขภาพดี และรู้สึกผ่อนคลายหลังการบริการ',
      featuresTitle: 'บริการของเรา',
      features: [
        'ตัดขนตามสไตล์ที่คุณต้องการ',
        'อาบน้ำด้วยผลิตภัณฑ์ที่อ่อนโยน',
        'ตัดเล็บอย่างปลอดภัยและไม่ทำให้สัตว์เครียด',
        'มีบริการบีบต่อมทุกการอาบน้ำ',
        'ทำความสะอาดหูเพื่อลดความเสี่ยงจากการติดเชื้อ',
        'แปรงฟันเพื่อสุขภาพช่องปากที่ดี',
        'ให้คำปรึกษาด้านการดูแลขนและสุขภาพสัตว์เลี้ยง',
      ],
      sections: [
        {
          heading: 'ทำไมต้องเลือกเราสำหรับการตัดขนสัตว์เลี้ยง?',
          body: 'โรงพยาบาลสัตว์เพ็ทไดเร็ค เชี่ยวชาญด้านการดูแลสัตว์เลี้ยงมากกว่า 20 ปี พร้อมทีมงานมืออาชีพที่มีใบรับรอง ให้บริการครบวงจร ทั้งตัดขน อาบน้ำ ตัดเล็บ บีบต่อม และแปรงฟัน มั่นใจได้ในคุณภาพและความปลอดภัยสูงสุดสำหรับสัตว์เลี้ยงของคุณ',
        },
        {
          heading: 'ตารางนัดหมายและราคา',
          body: 'โรงพยาบาลสัตว์เพ็ทไดเร็คให้บริการนัดหมายง่าย ๆ ผ่านไลน์ โทรศัพท์ หรือเฟซบุ๊ก พร้อมสอบถามรายละเอียดได้ตลอดเวลา ด้วยเวลาที่ปรับเปลี่ยนได้ตามความสะดวกของคุณ นอกจากนี้ยังมีบริการรถรับ-ส่งถึงบ้าน เพื่อความสะดวกสบายสูงสุดสำหรับเจ้าของและลูกๆ',
        },
      ],
    },
  },
  {
    slug: 'pet-hotel',
    icon: 'night_shelter',
    name: 'โรงแรมสัตว์เลี้ยง',
    cardTitle: 'โรงแรมสัตว์เลี้ยง',
    shortDescription:
      'ที่พักปลอดภัย สะดวกสบาย พร้อมเจ้าหน้าที่ดูแลตลอด 24 ชั่วโมง',
    image: petHotelImg,
    detail: {
      title: 'โรงแรมสัตว์เลี้ยงที่ปลอดภัยและสะดวกสบาย',
      intro:
        'โรงแรมสัตว์เลี้ยงของโรงพยาบาลสัตว์เพ็ทไดเร็ค เปิดให้บริการตลอด 24 ชั่วโมง พร้อมเจ้าหน้าที่ดูแลตลอดเวลา มั่นใจได้ในความปลอดภัย ตั้งอยู่ใจกลางทองหล่อ เดินทางสะดวก เหมาะสำหรับเจ้าของที่ต้องการความอุ่นใจทุกเวลา!',
      featuresTitle: 'บริการของเรา',
      features: [
        'ที่พักแบบห้องส่วนตัวหรือห้องรวมตามความต้องการ',
        'ตรวจสุขภาพเป็นระยะเพื่อความปลอดภัย',
        'การจัดการอาหารที่เหมาะสมกับแต่ละสัตว์เลี้ยง',
        'เวลาเล่นและออกกำลังกายเพื่อสุขภาพที่ดี',
        'บริการรับ-ส่งสัตว์เลี้ยงไปยังโรงแรมและกลับบ้าน',
        'การดูแลพิเศษสำหรับสัตว์เลี้ยงที่มีความต้องการเฉพาะ',
      ],
      sections: [
        {
          heading: 'ทำไมต้องเลือกโรงแรมสัตว์เลี้ยงของเรา?',
          body: 'เลือกพักที่โรงแรมสัตว์เลี้ยงของเรา เพราะเรามีความใส่ใจในทุกรายละเอียด เรามีพื้นที่กว้างขวางให้น้องวิ่งเล่นและเดินอย่างอิสระ ช่วยให้น้องผ่อนคลายและมีความสุขตลอดการเข้าพัก พร้อมเจ้าหน้าที่ดูแลตลอด 24 ชั่วโมง เพื่อความสะดวกสบายและความปลอดภัยสูงสุดสำหรับสัตว์เลี้ยงของคุณ',
        },
        {
          heading: 'ตารางนัดหมายและราคา',
          body: 'โรงพยาบาลสัตว์เพ็ทไดเร็คมีตารางนัดยืดหยุ่นตามความสะดวกของลูกค้า ทั้งระยะสั้นและระยะยาว พร้อมโปรโมชันพิเศษสำหรับการบริการต่าง ๆ เพื่อให้คุณและสัตว์เลี้ยงได้รับความคุ้มค่าและบริการที่ดีที่สุด',
        },
      ],
    },
  },
  {
    slug: 'pet-transportation',
    icon: 'local_taxi',
    name: 'รับ-ส่งสัตว์เลี้ยง',
    cardTitle: 'บริการรับ-ส่งสัตว์เลี้ยง',
    shortDescription:
      'รถรับ-ส่งถึงบ้าน ปลอดภัยทุกการเดินทาง ทั้งนัดปกติและกรณีฉุกเฉิน',
    image: petTransportationImg,
    detail: {
      title: 'บริการรับ-ส่งสัตว์เลี้ยงที่สะดวกและปลอดภัย',
      intro:
        'โรงพยาบาลสัตว์เพ็ทไดเร็คมีบริการรถรับ-ส่งสะดวกสบาย พร้อมทำนัดได้ตามต้องการ ทีมงานมืออาชีพที่มีความเชี่ยวชาญดูแลสัตว์เลี้ยงอย่างเต็มที่ เพื่อความสะดวกสบายและปลอดภัยสูงสุดสำหรับคุณและสัตว์เลี้ยงของคุณ',
      featuresTitle: 'บริการของเรา',
      features: [
        'รับส่งจากบ้านไปยังโรงพยาบาลอย่างสะดวกและรวดเร็ว',
        'รับส่งจากโรงพยาบาลกลับบ้านด้วยความปลอดภัยสูงสุด',
        'การตอบสนองอย่างรวดเร็วในกรณีฉุกเฉินเพื่อการดูแลที่ทันท่วงที',
        'การดูแลเฉพาะสำหรับสัตว์เลี้ยงที่มีความต้องการพิเศษ เช่น สัตว์เลี้ยงที่มีโรคประจำตัวหรือสัตว์เลี้ยงที่ไม่คุ้นเคยกับการเดินทาง',
      ],
      sections: [
        {
          heading: 'ทำไมต้องเลือกบริการรับ-ส่งสัตว์เลี้ยงของเรา?',
          body: 'เลือกเราเพราะเรามีการดูแลสัตว์เลี้ยงอย่างดีเยี่ยม พร้อมบริการรถรับ-ส่งที่สะดวกสบาย ไม่ต้องเสียเวลาเดินทางเอง ทีมงานมืออาชีพของเราพร้อมดูแลสัตว์เลี้ยงของคุณอย่างใส่ใจในทุกขั้นตอนเพื่อความปลอดภัยและความสุขของน้อง!',
        },
      ],
    },
  },
  {
    slug: 'pet-shop',
    icon: 'storefront',
    name: 'เพ็ทช็อป',
    cardTitle: 'ร้านค้าอุปกรณ์สัตว์เลี้ยง',
    shortDescription:
      'อาหาร ขนม ของเล่น และอุปกรณ์คุณภาพสูง ครบทุกสิ่งที่น้องต้องการ',
    image: petShopImg,
    detail: {
      title: 'ร้านค้าอุปกรณ์สัตว์เลี้ยงครบวงจรที่ทองหล่อ 20',
      intro:
        'ร้านค้าอุปกรณ์สัตว์เลี้ยงของเรา มีสินค้าหลายหลายครบครัน ทั้งขนม อาหารสัตว์เลี้ยงตั้งแต่เล็กถึงใหญ่ รวมถึงอาหารเฉพาะทางสำหรับรักษาโรค ของเล่น บ้านสัตว์ ทรายแมว และอุปกรณ์ต่าง ๆ ที่จำเป็นสำหรับการดูแลสัตว์เลี้ยงทุกประเภท เรามีครบทุกสิ่งที่สัตว์เลี้ยงของคุณต้องการ!',
      featuresTitle: 'สินค้าที่เราจำหน่าย',
      features: [
        'อาหารสัตว์เลี้ยงที่มีคุณภาพสูงและหลากหลายสูตร',
        'ของเล่นที่ออกแบบมาเพื่อกระตุ้นการเล่นและการออกกำลังกาย',
        'อุปกรณ์ดูแลขนและสุขภาพที่ทันสมัย',
        'เตียงและกระเป๋าสัตว์เลี้ยงที่สบายและปลอดภัย',
        'ผลิตภัณฑ์เสริมอาหารและวิตามินเพื่อสุขภาพที่ดี',
      ],
      sections: [
        {
          heading: 'โปรโมชั่นและส่วนลด',
          body: 'เราจัดโปรโมชั่นและส่วนลดตามเทศกาลสำคัญสำหรับอาหารและสินค้าในเพ็ทช็อป พร้อมทั้งมีโปรโมชันพิเศษมากมายที่จะมอบให้ในอนาคต เพื่อให้คุณและสัตว์เลี้ยงได้เพลิดเพลินกับการดูแลที่คุ้มค่าและมีความสุข!',
        },
      ],
    },
  },
];

export const CONTACT = {
  phone: '02-714-7544',
  phoneHref: 'tel:+6627147544',
  email: 'petdirect.hospital@gmail.com',
  lineUrl: 'https://line.me/R/ti/p/@iqp1573a',
  lineId: '@iqp1573a',
  address: '946/10-12 ซ.ทองหล่อ 20 ถ.สุขุมวิท 55, แขวงคลองตันเหนือ เขตวัฒนา, กรุงเทพ 10110',
  mapUrl:
    'https://www.google.com/maps/place/Pet+Direct/@13.739397,100.582732,17z/data=!3m1!4b1!4m5!3m4!1s0x30e29e51e82593ef:0x878031cdab86722f!8m2!3d13.739397!4d100.582732',
  mapEmbedUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3875.653810166989!2d100.58273197490718!3d13.739397186651233!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29e51e82593ef%3A0x878031cdab86722f!2zUGV0IERpcmVjdCBIb3NwaXRhbCDguYLguKPguIfguJ7guKLguLLguJrguLLguKXguKrguLHguJXguKfguYwg4LmA4Lie4LmH4LiX4LmE4LiU4LmA4Lij4LmH4LiEICjguJfguK3guIfguKvguKXguYjguK0gMjAp!5e0!3m2!1sen!2sth!4v1726893067384!5m2!1sen!2sth',
};

export default services;
